import VueRouter from 'vue-router';
import Vue from 'vue';
import { store } from '../store';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'homeLink',
		component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/runtask/singletask',
		name: 'runTaskLink',
		component: () => import(/* webpackChunkName: "runtask" */ '../views/runtask/RunTask.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/runtask/multitask',
		name: 'multiTaskLink',
		component: () => import(/* webpackChunkName: "runtask" */ '../views/runtask/MultiTask.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/login',
		name: 'loginLink',
		component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
		beforeEnter: guardExternal
	},
	{
		path: '/password',
		name: 'passwordLink',
		component: () => import(/* webpackChunkName: "password" */ '../views/misc/PasswordChange.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/common/processes',
		name: 'processesLink',
		component: () => import(/* webpackChunkName: "processes" */ '../views/common/Processes.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/common/services',
		name: 'servicesLink',
		component: () => import(/* webpackChunkName: "services" */ '../views/common/Services.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/common/logs',
		name: 'logsLink',
		component: () => import(/* webpackChunkName: "logs" */ '../views/common/Logs.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/visualization',
		name: 'visualsLink',
		component: () => import(/* webpackChunkName: "visuals" */ '../views/config/Visuals.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/configtree',
		name: 'configTreeLink',
		component: () => import(/* webpackChunkName: "configtree" */ '../views/config/ConfigTree.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/configtasks',
		name: 'configTasksLink',
		component: () => import(/* webpackChunkName: "configtasks" */ '../views/config/ConfigTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/rolesections',
		name: 'roleSectionsLink',
		component: () => import(/* webpackChunkName: "rolesections" */ '../views/config/RoleSections.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/roletasks',
		name: 'roleTasksLink',
		component: () => import(/* webpackChunkName: "roletasks" */ '../views/config/RoleTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/config/sectiontasks',
		name: 'sectionTasksLink',
		component: () => import(/* webpackChunkName: "sectiontasks" */ '../views/config/SectionTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/status/run',
		name: 'statusRunLink',
		component: () => import(/* webpackChunkName: "statusrun" */ '../views/status/RunningTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/status/finish',
		name: 'statusFinishLink',
		component: () => import(/* webpackChunkName: "statusfinish" */ '../views/status/FinishedTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/status/delete',
		name: 'statusDeleteLink',
		component: () => import(/* webpackChunkName: "statusdelete" */ '../views/status/DeletedTasks.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/bases',
		name: 'referenceBasesLink',
		component: () => import(/* webpackChunkName: "referencebases" */ '../views/reference/Bases.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/sections',
		name: 'referenceSectionsLink',
		component: () => import(/* webpackChunkName: "referencesections" */ '../views/reference/Sections.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/servers',
		name: 'referenceServersLink',
		component: () => import(/* webpackChunkName: "referenceservers" */ '../views/reference/Servers.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/users',
		name: 'referenceUsersLink',
		component: () => import(/* webpackChunkName: "referenceusers" */ '../views/reference/Users.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/appparams',
		name: 'referenceAppParamsLink',
		component: () => import(/* webpackChunkName: "referenceappparams" */ '../views/reference/AppParams.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/roles',
		name: 'referenceRolesLink',
		component: () => import(/* webpackChunkName: "referenceroles" */ '../views/reference/Roles.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/reference/upgrades',
		name: 'referenceUpgradesLink',
		component: () => import(/* webpackChunkName: "referenceroles" */ '../views/reference/Upgrades.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/scheduler/editor',
		name: 'schedulerLink',
		component: () => import(/* webpackChunkName: "scheduler" */ '../views/cron/Scheduler.vue'),
		beforeEnter: guardInternal
	},
	{
		path: '/scheduler/history',
		name: 'schedulerHistoryLink',
		component: () => import(/* webpackChunkName: "schedulerhistory" */ '../views/cron/History.vue'),
		beforeEnter: guardInternal
	},

	{
		path: '*',
		redirect: '/'
	}
];

export const router = new VueRouter({
	routes
});

function guardExternal(to, from, next) {
	//console.log(to);
	store.getters.isUserLoggedIn ? next('/runtask/singletask') : restoreSession('external', next);
}

function guardInternal(to, from, next) {
	if (store.getters.isUserLoggedIn) {
		//console.log(to);
		if (store.getters.currentUserDenial) {
			if (store.getters.currentUserDenial.includes(to.name)) {
				next('/');
			}
			else next();
		}
		else next();
	}
	else {
		restoreSession('internal', next);
	}
	// store.getters.isUserLoggedIn ? next() : restoreSession('internal', next);
}

function restoreSession(call, next) {
	let waAuth = {
		token: '',
		tokenId: '',
		userid: '',
		userId: '',
		roleid: '',
		roletype: ''
	};
	const savedAuth = Vue.localStorage.get('wa-auth');
	if (savedAuth) {
		const auth = JSON.parse(savedAuth);
		waAuth = {
			login: auth.login || '',
			token: auth.token || '',
			tokenId: auth.tokenId || '',
			userid: auth.userid || '',
			roleid: auth.mpj || '',
			roletype: auth.tpj || '',
		};
	}

	let waConnection = {
		login: '',
		connection: '',
		language: ''
	};
	const savedConnection = Vue.localStorage.get('wa-connection');
	if (savedConnection) {
		const connect = JSON.parse(savedConnection);
		waConnection = {
			login: connect.login || '',
			connection: connect.connection || '',
			language: connect.language || ''
		};
	}
	if ((waConnection.connection && waAuth.token && waAuth.tokenId && waAuth.userid)) {
		store.commit('setUser', {
			login: waAuth.login,
			connection: waConnection.connection,
			language: waConnection.language,
			token: waAuth.token,
			tokenId: waAuth.tokenId,
			userid: waAuth.userid,
			roleid: waAuth.roleid,
			roletype: waAuth.roletype
		});
		//если есть пользователь и он идет внутри, давать ему. Если он регистрировался - на главную страницу
		call === 'internal' ? next() : next('/runtask/singletask');
	}
	else {
		if (call === 'internal') {
			next('/login');
		}
		else {
			next();
		}
	}
}
